export default __webpack_public_path__ + "img/pngf nord.8805d7e8.jpg";